export default __webpack_public_path__ + "static/21_30-e77beeb7c4481f8d31afd4d0c5f09a92.png";